import { render, staticRenderFns } from "./WhatsappTemplatesForm.vue?vue&type=template&id=0eb4832a&scoped=true&"
import script from "./WhatsappTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappTemplatesForm.vue?vue&type=style&index=0&id=0eb4832a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4832a",
  null
  
)

export default component.exports